import React, {useEffect, useState} from "react";
import { Card } from "react-bootstrap";
import ImageLightbox from "./ImageLightbox";

const ProofImageCard = ({
    src,
    alt = "Proof image",
    fallbackSrc,
    maxHeight = 500,
    onClick,
}) => {
    const [lightboxSrc, setLightboxSrc] = useState(null);
    const [displaySrc, setDisplaySrc] = useState(src);

    useEffect(() => {
        setDisplaySrc(src);
    }, [src]);

    if (!src) return null;

    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick(displaySrc || src);
            return;
        }
        setLightboxSrc(displaySrc || src);
    };

    return (
        <>
            <Card
                className="w-100"
                style={{
                    border: "1px solid #adb5bd",
                    borderRadius: 6,
                    overflow: "hidden",
                    boxShadow: "0 .125rem .25rem rgba(0,0,0,.075)",
                    background: "#fff",
                }}
            >
                <Card.Body
                    className="d-flex align-items-center justify-content-center p-2"
                    style={{
                        minHeight: 160,
                    }}
                >
                    <img
                        src={displaySrc || src}
                        alt={alt}
                        className="d-block"
                        style={{
                            width: "auto",
                            height: "auto",
                            maxWidth: "100%",
                            maxHeight,
                            objectFit: "contain",
                            borderRadius: 6,
                            cursor: "zoom-in",
                            padding: 3,
                        }}
                        onClick={handleClick}
                        onError={(e) => {
                            if (!fallbackSrc) return;
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = fallbackSrc;
                            setDisplaySrc(fallbackSrc);
                        }}
                    />
                </Card.Body>
            </Card>
            <ImageLightbox
                src={lightboxSrc}
                alt={alt}
                onClose={() => setLightboxSrc(null)}
            />
        </>
    );
};

export default ProofImageCard;
